import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

const CategoryProductsPage = () => {
  const { categoryId } = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `https://hijabsin.com/wp-json/wc/v3/products?category=${categoryId}&per_page=100&page=1`,
          {
            auth: {
              username: 'ck_53f992c38e58c2733ac1d6dfcc3cebcfe5845d49',
              password: 'cs_73f39f1fafa45c544f44ab9f652dac3b822b8149',
            },
          }
        );
        setProducts(response.data.map(product => ({
          ...product,
          updatedStock: product.stock_quantity || 0,
        })));
      } catch (error) {
        console.error('Error fetching products:', error);
        setError('Failed to load products.');
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [categoryId]);

  const updateStock = (id, increment) => {
    setProducts((prevProducts) =>
      prevProducts.map((product) =>
        product.id === id
          ? {
              ...product,
              updatedStock: Math.max(0, product.updatedStock + increment),
            }
          : product
      )
    );
  };

  const saveStock = async (id) => {
    const product = products.find((p) => p.id === id);
    if (!product) return;

    try {
      await axios.put(
        `https://hijabsin.com/wp-json/wc/v3/products/${id}`,
        { stock_quantity: product.updatedStock },
        {
          auth: {
            username: 'ck_53f992c38e58c2733ac1d6dfcc3cebcfe5845d49',
            password: 'cs_73f39f1fafa45c544f44ab9f652dac3b822b8149',
          },
        }
      );
      alert(`${product.name} stock updated to ${product.updatedStock}.`);
    } catch (error) {
      console.error('Error updating stock:', error);
      alert('Failed to save stock. Please try again.');
    }
  };

  return (
    <div>
      <h1 style={{ marginTop: '20px', marginLeft: '20px' }}>Products in Category</h1>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <div className="spinner"></div>
        </div>
      ) : error ? (
        <p style={{ textAlign: 'center', color: 'red' }}>{error}</p>
      ) : (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', padding: '5%', rowGap: '20px' }}>
          {products.length === 0 && <h3>Category is empty</h3>}
          {products.map((product) => (
            <div
              key={product.id}
              className='item-box'
            >
              <div>
                {product.images[0] && (
                  <img
                    src={product.images[0].src}
                    alt={product.name}
                    style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                  />
                )}
                <p>Status: {product.stock_status}</p>
              </div>
              <div>
              <h3>{product.name}</h3>
              <p>Price: ${product.price}</p>
              <div
                style={{
                  display: 'flex',
                  gap: '10px',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    width: 'fit-content',
                    padding: '5px',
                    border: '1px solid black',
                    backgroundColor: 'orange',
                    cursor: 'pointer',
                  }}
                  onClick={() => updateStock(product.id, -1)}
                >
                  -
                </div>
                <p>Stock: {product.updatedStock}</p>
                <div
                  style={{
                    width: 'fit-content',
                    padding: '5px',
                    border: '1px solid black',
                    backgroundColor: 'orange',
                    cursor: 'pointer',
                  }}
                  onClick={() => updateStock(product.id, 1)}
                >
                  +
                </div>
              </div>
              <div
                style={{
                  width: '80%',
                  backgroundColor: 'red',
                  marginTop: '10px',
                  textAlign: 'center',
                  border: '1px solid black',
                  color: '#fff',
                  cursor: 'pointer',
                }}
                onClick={() => saveStock(product.id)}
              >
                Save
              </div>
            </div>
          </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoryProductsPage;
